<div class="highlighted-container container">
    <div class="row">
        <div class="highlighted">  
            <div class="region region-highlighted">
                <h1 class="page-header">
                    <span>{{ 'REQUEST_PHONE_CHANGE_HEADING' | translate }}</span>
                </h1>
            </div>
        </div>
    </div>
</div>

<div class="main-container container">
    <div class="row" *ngIf="!isActiveLease">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <p class="page-subtitle">{{ 'COMMON_LBL_ERROR_MSG_NO_ACTIVE_LEASE' | translate }}</p>
            <p></p>
        </section>
        <section class="col-sm-2"></section>
    </div>
    <div class="row" *ngIf="isActiveLease">
        <section class="col-sm-2"></section>
        <section class="col-sm-8">
            <div class="region region-content">
                <form class="custom-from" #customForm="ngForm" (ngSubmit)="submitForm(customForm)" novalidate>
                    <div class="row">
                        <section class="col-sm-6 lb"><label class="star">*</label>{{ 'REQUEST_PHONE_CHANGE_INPUT_HOME_PHONE' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="homePhone" name="homePhone" 
                                [(ngModel)]="request.homePhone"   
                                [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.homePhone.errors }"
                                placeholder="{{ 'COMMON_LBL_REQUIRED' | translate }}"                                              
                                (input)="homePhoneValidator($event)" 
                                [pattern]="phoneNumberPattern" required maxlength="10"/>
                        </section>
                        <section class="col-sm-6 lb">{{ 'REQUEST_PHONE_CHANGE_INPUT_WORK_PHONE' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="businessPhone" name="businessPhone" 
                                [(ngModel)]="request.businessPhone"   
                                [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.businessPhone.errors }"         
                                (input)="businessPhoneValidator($event)" 
                                [pattern]="phoneNumberPattern" maxlength="10"/>
                        </section>
                        <section class="col-sm-6 lb">{{ 'REQUEST_PHONE_CHANGE_INPUT_MOBILE_PHONE' | translate }}</section>
                        <section class="col-sm-6">
                            <input type="text" 
                                class="form-control" 
                                id="mobilePhone" name="mobilePhone" 
                                [(ngModel)]="request.mobilePhone"   
                                [ngClass]="{ 'is-invalid': formSubmitted && customForm.controls.mobilePhone.errors }"         
                                (input)="mobilePhoneValidator($event)" 
                                [pattern]="phoneNumberPattern" maxlength="10"/>
                        </section>
                    </div>
                    <div *ngIf="formSubmitted && customForm.invalid" class="row" style="margin: auto;">
                        <div class="col-sm-12 error-note">
                            <label translate="COMMON_LBL_FORM_ERR_NOTE"></label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6"></div>
                        <div class="col-md-6">
                            <button type="submit" class="btn btn-secondary action-row">{{ 'COMMON_BTN_SUBMIT' | translate }}</button>
                        </div>
                    </div>
                </form>
            </div>
        </section>
        <section class="col-sm-2"></section>
    </div>
</div>    
